var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoundaries = function SvgBoundaries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M47.67 55a3.67 3.67 0 1 0 0-7.33 3.67 3.67 0 0 0 0 7.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M22 4.58A6.42 6.42 0 0 0 15.58 11v56.73a10.1 10.1 0 0 0 7.43 9.73l30.3 8.26a6.42 6.42 0 0 0 8.1-6.19v-56.3a6.42 6.42 0 0 0-5.26-6.32l-33.99-6.18c-.47-.08-.64-.65-.16-.65h44c.5 0 .92.41.92.92v62.33h5.5V11A6.42 6.42 0 0 0 66 4.58H22Zm-.92 63.15v-51.6l34.08 6.2a.9.9 0 0 1 .76.9v56.3a.92.92 0 0 1-1.16.89l-30.3-8.27a4.58 4.58 0 0 1-3.38-4.42Z",
    clipRule: "evenodd"
  })));
};
export default SvgBoundaries;